/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SEARCH_SPLIT_BROADCAST
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted broadcast helper functions from Search.tsx.
 *
 * Related Screens / Modules:
 * - client/src/components/search/Search.tsx (refactored)
 */

import { BroadcastGroup, UserInfo } from "../../../interfaces/broadcast";
import { FlattenedBroadcastItem } from "../../broadcast/BroadcastItemCard";

// [2026-02-10] Mobile: Map FlattenedBroadcastItem to FlatItem format for MobileBroadcastList
export interface FlatItemForMobile {
  itemNo: number;
  manufacturer: string;
  partNumber?: string | null;
  model?: string | null;
  title?: string | null;
  quantity: number;
  condition?: string | null;
  price?: number | null;
  currency?: string | null;
  categories?: string[];
  description?: string | null;
  country?: string | null;
  isActive?: boolean;
  broadcastType: "WTB" | "WTS";
  broadcastId: string;
  createdAt: string;
  userId?: string | UserInfo;
  status?: "draft" | "sent" | "archived" | "deleted";
  sentAt?: string | null;
}

export const mapSearchBroadcastToFlatItem = (item: FlattenedBroadcastItem): FlatItemForMobile => ({
  ...item,
  broadcastType: (item.broadcastGroup?.type || "WTS") as "WTB" | "WTS",
  broadcastId: item.broadcastGroup?._id || "",
  createdAt: item.broadcastGroup?.createdAt || "",
  userId: item.broadcastGroup?.userId || "",
  status: item.broadcastGroup?.status,
  sentAt: item.broadcastGroup?.sentAt || null,
});

// [2025-12-30] Broadcast helpers: extracted from Search.tsx
export const flattenBroadcasts = (broadcasts: BroadcastGroup[]): FlattenedBroadcastItem[] => {
  const flattened: FlattenedBroadcastItem[] = [];
  broadcasts.forEach((broadcast) => {
    const companyName =
      typeof broadcast.userId === "object" && broadcast.userId
        ? broadcast.userId.companyName ||
          `${broadcast.userId.firstName} ${broadcast.userId.lastName}`.trim()
        : "";
    const userCountry =
      typeof broadcast.userId === "object" && broadcast.userId
        ? broadcast.userId.country || undefined
        : undefined;
    broadcast.broadcast.forEach((item) => {
      flattened.push({
        ...item,
        broadcastGroup: broadcast,
        companyName,
        userCountry,
      });
    });
  });
  return flattened;
};

